import { PopoverRangeDate } from '../../components/popoverRangeDate/PopoverRangeDate';
import { PopoverCheckboxFilter } from '../../components/popoverCheckboxFilter/PopoverCheckboxFilter';
import { PopoverRadioFilter } from '../../components/popoverRadioFilter/PopoverRadioFilter';
import { DrawerCustom } from '../../components/drawer/Drawer';
import { Button } from '../../components/buttons/Button';
import { optionsStatusPayment, optionsSort, paymentTypes } from '../../static/data';
import { FunnelIcon, AdjustmentsHorizontalIcon, ArrowsUpDownIcon } from '@heroicons/react/20/solid';

const PAYMENT_TYPE_OPTIONS = paymentTypes
	.filter((p) => p.id !== 'allTypes')
	.map((p) => ({
		value: p.description,
		label: p.name,
		description: p.description,
	}));

export const DrawerFiltersPayments = ({
	isOpen,
	toggleDrawer,
	formData,
	setFormData,
	sortValue,
	onSortChange,
	onClear,
	onApply,
}) => {
	return (
		<DrawerCustom
			isOpen={isOpen}
			toggleDrawer={toggleDrawer}
			direction='left'
			title='Filtros de pagos'
			subtitle='Selecciona y aplica filtros para el historial.'
			footer={(
				<div className='flex items-center justify-end gap-4 overflow-hidden'>
					<Button type='button' variant='secondary' onClick={toggleDrawer}>
						Cerrar
					</Button>
					<Button type='button' variant='reject' onClick={onClear}>
						Limpiar
					</Button>
					<Button type='button' variant='primary' onClick={onApply}>
						Aplicar
					</Button>
				</div>
			)}
		>
			<div className='flex w-full flex-col gap-4 px-6 py-4'>
				<div className='rounded-2xl border border-indigo-100 bg-gradient-to-r from-indigo-50 via-white to-violet-50 px-4 py-4 shadow-sm'>
					<div className='flex items-start gap-3'>
						<div className='flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-indigo-600 text-white shadow-md shadow-indigo-400/30'>
							<FunnelIcon className='h-5 w-5' aria-hidden='true' />
						</div>
						<div className='min-w-0'>
							<h3 className='text-sm font-semibold text-gray-900'>Refina tu búsqueda</h3>
							<p className='mt-1 text-xs leading-relaxed text-gray-600'>
								Filtra por fechas de registro del pago, estatus, tipo y orden de la lista.
							</p>
						</div>
					</div>
					<div className='mt-3 inline-flex items-center gap-2 rounded-full border border-indigo-200 bg-white/80 px-3 py-1 text-[11px] font-semibold uppercase tracking-wide text-indigo-700'>
						<AdjustmentsHorizontalIcon className='h-3.5 w-3.5' aria-hidden='true' />
						Filtros
					</div>
				</div>

				<PopoverRadioFilter
					value={sortValue}
					onChange={onSortChange}
					options={optionsSort}
					title='Orden por fecha de registro'
					subtitle='Más reciente o más antiguo según la fecha en que se registró el pago.'
					icon={ArrowsUpDownIcon}
					placeholderLabel='Ordenar por'
				/>

				<PopoverCheckboxFilter
					state={formData}
					setState={setFormData}
					property='status'
					options={optionsStatusPayment}
					title='Estatus del pago'
					subtitle='Selecciona uno o varios estatus.'
					placeholderLabel='Estatus del pago'
					handleApllyFilters={() => {}}
					handleRemoveFilter={() => {}}
					hideActionButtons
				/>

				<PopoverCheckboxFilter
					state={formData}
					setState={setFormData}
					property='paymentType'
					options={PAYMENT_TYPE_OPTIONS}
					title='Tipo de pago'
					subtitle='Suscripción y/o pre registro.'
					placeholderLabel='Tipo de pago'
					handleApllyFilters={() => {}}
					handleRemoveFilter={() => {}}
					hideActionButtons
				/>

				<PopoverRangeDate
					state={formData}
					setState={setFormData}
					properties={['startDate', 'endDate']}
					popoverTitle='Fecha de registro del pago'
					popoverSubtitle='Filtra por la fecha en que se registró el pago en el sistema.'
					emptySummaryLabel='Fechas de registro'
					showMonthYearSelects
					handleApllyFilters={() => {}}
					handleRemoveFilter={() => {}}
					hideActionButtons
				/>
			</div>
		</DrawerCustom>
	);
};
